export const parseMaxCapacity = (val) => {
  if (val === undefined || val === null || val === "") return "-"
  const n = parseInt(val)
  return isNaN(n) ? "-" : n
}

export const getOccupancyPct = (enrolled, max) => {
  const m = parseMaxCapacity(max)
  if (m === "-") return 0
  if (m === 0) return 0
  return enrolled / m
}
